import { QuestionCircleOutlined } from '@ant-design/icons'
import { HeaderView } from '@merchant-backend/common-components'
import { Button } from 'hljd'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
// import ValidateModal from './ValidateModal'
import AddNewModal from './AddNewModal'
import addStore from './AddNewModal/store'
import ChangePwdModal from './ChangePwdModal'
import List from './List'
import ModifyRemarks from './ModifyRemarks'
import store from './store'

@observer
export default class extends Component {
  render() {
    const extra = () => {
      return (
        /*<div>
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={() => {
              addStore.addServiceModal()
            }}
          >
            + 新增员工账号
          </Button>
        </div>*/
        <div>
          <Button
            type="primary"
            style={{ marginLeft: 20 }}
            onClick={() => {
              addStore.serviceManage()
            }}
          >
            管理客服账号
          </Button>
        </div>
      )
    }
    const title = (
      <span>
        私信客服管理
        <a href="#/localMerchant/serviceDistriRule">
          <QuestionCircleOutlined style={{ marginLeft: 6, color: '#448afc' }} />
        </a>
      </span>
    )
    const { $pagination = {} } = store
    return (
      <HeaderView title={title} extra={extra()}>
        <p style={{ height: 50, lineHeight: '50px', fontSize: 14 }}>{`共${
          $pagination.total
        }条数据`}</p>
        <List />
        <AddNewModal />
        <ModifyRemarks />
        <ChangePwdModal />
      </HeaderView>
    )
  }
}
